/**
 * s2k-service.js
 * @author: Bernhard Wolkerstorfer
 * 
 * Description: Service calling object.
 * 
 * Copyright (c) 2012 Amazon.com, Inc. All rights reserved.
 */
import { getState } from "../state/state";

/**
 * @constructor
 */
const SendToKindleService = function () {};

SendToKindleService.prototype = {
    // ######## Constants ########
    S3_HTTP_VERB: "PUT",
        
    // ######## Public Methods ########
    /**
     * Handle an XMLHttpRequest.
     * @param {Object} ajaxRequest  Settings for the AJAX request
     */
    ajax: function (ajaxRequest) {
        // Validate the input data.
        ajaxRequest = ajaxRequest || {};
        ajaxRequest.path = ajaxRequest.path || "";
        ajaxRequest.url = ajaxRequest.url || "";
        ajaxRequest.type = ajaxRequest.type || "GET";
        ajaxRequest.data = ajaxRequest.data || undefined;
        ajaxRequest.success = ajaxRequest.success || function () {};
        ajaxRequest.error = ajaxRequest.error || function () {};
        ajaxRequest.complete = ajaxRequest.complete || function () {};
        ajaxRequest.timeout = ajaxRequest.timeout || 30000;
        ajaxRequest.async = ajaxRequest.async || true;
        ajaxRequest.cache = ajaxRequest.cache || false;
        ajaxRequest.binary = ajaxRequest.binary || false;
        ajaxRequest.responseType = ajaxRequest.responseType || "";
        ajaxRequest.dataType = ajaxRequest.dataType || "text";
        ajaxRequest.isUploadToS3 = ajaxRequest.isUploadToS3 || false;
        ajaxRequest.isDownloadBinary = ajaxRequest.isDownloadBinary || false;
        ajaxRequest.isJSONContentType = ajaxRequest.isJSONContentType || false;
        ajaxRequest.isCsrfRequired = ajaxRequest.isCsrfRequired || false;

        if (ajaxRequest.data && ajaxRequest.binary === false) {
            if (ajaxRequest.isJSONContentType) {
                ajaxRequest.data = JSON.stringify(ajaxRequest.data);
            } else {
                ajaxRequest.data = $.param(ajaxRequest.data);
            }
        }

        //todo: for better security model, we would better to avoid pass the url directly, instead, we need to
        // pass necessary parameter and generate the url in background page. But in other case, it's not easy to
        // implement that since there are too many kinds of urls.
        this.sendExtensionMessage("service-common-call", {"request": ajaxRequest}, function (message) {
            if (message.success) {
                ajaxRequest.success(message.data, message.contentType);
                ajaxRequest.complete();
            } else {
                ajaxRequest.error(message.xhr, message.statusCode, message.statusText);
                ajaxRequest.complete();
            }
        }.bind(this));
    },

    /**
     * Convert data to binary representation.
     * @param data  Data
     */
    convertToBinary: function (data) {
        // Encode UCS-2 as UTF-8.
        var utf8Data = unescape(encodeURIComponent(data));
        
        // Create a buffer for UTF-8.
        var buffer = new ArrayBuffer(utf8Data.length);
        
        // Create an array buffer view.
        var udata = new Uint8Array(buffer);
        
        // Store the data in the binary buffer.
        for (var i = 0, len = utf8Data.length; i < len; i++) {
            udata[i] = utf8Data.charCodeAt(i);
        }
        
        return udata;
    },

    /**
     * Fetch an upload URL for the data.
     * @param state     Transfer State
     */
    getUploadUrl: function (state) {
        if (state.binaryData && state.binaryData.byteLength > 0) {

            this.ajax({
                type: "POST",
                dataType: "json",
                path: "/document-url",
                isJSONContentType: true,
                isCsrfRequired: true,
                data: {
                    "appName": `${BUILD_PROPS.__platformName__}_${getState().injectionContext}`,
                    "appVersion": BUILD_PROPS.__version__,
                    "s2kGuid": getState().s2kGuid,
                    "fileSize": state.binaryData.byteLength,
                    "contentType": "",
                    /*parameters used for falling back to old mason api.*/
                    "extName":`${BUILD_PROPS.__platformName__}_${getState().injectionContext}`,
                    "extVersion": BUILD_PROPS.__version__,
                    "action": "uploadUrl"
                },
                success: function (data) {
                    // the status(false) is added in case of failing to parse response.
                    if (data.status !== false) {
                        state.uploadUrl = data.uploadUrl;
                        state.stkToken = data.stkToken;
                        this.uploadToS3(state);
                    } else {

                        // Redirect the customer to the preview.
                        this.redirectToPreview(true, data.setupRequired, data.authRequired);
                    }
                }.bind(this),
                error: function () {
                    window.console.log("getUploadUrl fail;");
                    if (state.error ) {
                        state.error();
                    }
                },
                complete: function () {

                }
            });
        }
        else if (state.error ) {
            state.error();
        }
    },
    
    /**
     * Upload data to S3.
     * @param state     Transfer State
     */
    uploadToS3: function (state) {

        // Upload the pDocs document to S3.
        this.ajax({
            url: state.uploadUrl,
            type: "PUT",
            data: state.formattedContent,
            cache: true,
            binary: true,
            isUploadToS3: true,
            success: function () {
                this.sendDocument(state);
            }.bind(this),
            error: function () {
                if (state.error ) {
                    state.error();
                }
            },
            complete: function () {

            }
        });
    },
    
    /**
     * Send document metadata.
     * @param state     Transfer State
     */
    sendDocument: function (state) {
        this.ajax({
            type: "POST",
            dataType: "json",
            path: "/send-v2",
            isJSONContentType: true,
            isCsrfRequired: true,
            data: {
                "extName": getState().injectionContext === "ocs" ? "chrome_ocs" : "chrome_preview",
                "extVersion": BUILD_PROPS.__version__,
                "inputFormat": "html",
                "stkGuid": getState().s2kGuid,
                "stkToken": state.stkToken,
                "title": state.title,
                "dataType": state.dataType,
                "author": state.author || state.source,
                "archive": true,
                "fileSize": state.binaryData.byteLength,
                "inputFileName": state.title + ".html",
                "batchId": "03e78dc1-c158-4e5c-fdsf-79607473d52b"
            },
            success: function (data) {
                // Emit the metrics.
                
                // Handle the result.
                if (data.status === true) {
                    state.success();
                }
                else {
                    state.error();
                }
            },
            error: function () {
                // Emit the metrics.
                
                // Handle the error.
                state.error();
            }
        });
    },    
    
    /**
     * Send the current extraction result to the Send to Kindle Service. 
     */
    sendToKindle: function () {
        const state = getState();
        if (state  && state.content ) {
            // Show send in progress alert
            state.statusMessage.showAlert("progress", "sendingToKindle");
            
            // Create a transfer state item for passing through the workflow.
            var transferState = state.content.asStorageJson(true);
            
            // Copy reference to metrics.
            transferState.metrics = state.metrics;
            
            // Load data into a binary buffer, if it contains a HTML document.
            if (!transferState.binaryData) {
                transferState.binaryData = this.convertToBinary(transferState.content);
            }
            
            // Setup event handler.
            transferState.success = function () {

            }.bind(this);
            
            transferState.error = function () {
                // Show send error alert
                state.statusMessage.showAlert("result", "generalError");

            }.bind(this);
            
            // Push content to history.
            this.sendExtensionMessage("store-content", {"content": state.content.asStorageJson()}, function () {
                if (!state.s2kGuid) {
                    window.console.log("Guid missing, update guid before sendtokindle");
                    this.sendExtensionMessage("extension-metadata", {"refresh": true}, function (message) {
                        state.s2kGuid = message.data.s2kGuid;
                        window.console.log("guid updated to: " + message.data.s2kGuid);
                        this.getUploadUrl(transferState);
                    }.bind(this));
                } else {
                    this.getUploadUrl(transferState);
                }
            }.bind(this));
        } else {
            window.location.console("SendToKindle fail: " + state.content);
            // Show send error alert
            state.statusMessage.showAlert("result", "generalError");
        }
    },
    
    /**
     * Update the customer's account with the default engine action.
     * @param action    Action
     * @param callback  Callback
     */
    setDefaultEngineAction: function (action, callback) {
        // Setup the global engine preferences through the GUID authentication mode.
        // Fire this call as fire and forget as we do not show anything.
        this.ajax({
            type: "POST",
            path: "/setup-engine",
            isCsrfRequired: true,
            data: {
                "action": "setup-engine",
                "s2kGuid": getState().s2kGuid,
                "setting": action === "SEND" ? action : "ASK"
            },
            complete: callback
        });
    },
    
    /**
     * Send a message to the extension.
     * This methods needs to be replace in the platform-specific files otherwise
     * it will just loop-back an object containing action and params. 
     * 
     * @param action    Action
     * @param data      Parameter
     */
    sendExtensionMessage(action, data, callback) {
        chrome.runtime.sendMessage({"action": action, "data": data}, function (response) {
            if (typeof callback !== 'undefined') {
                callback(response);
            }
        });
    },
};

export { SendToKindleService };
